import { render, staticRenderFns } from "./EditContractTemplate.vue?vue&type=template&id=6a5b5666&"
import script from "./EditContractTemplate.vue?vue&type=script&lang=ts&"
export * from "./EditContractTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports